import { BlogHero } from '../../components/blogHero/blogHero.comp';
import { BlogPosts } from '../../components/blogPosts/blogPosts.comp';
import { Layout } from '../../components/layout/layout.comp';
import { getDataFromDB } from '../../lib/mongodb';
import { BN_ARTICLE_SLUGS } from '../../lib/bnArticleSlugs';
import { IBlogPage } from '../../types';

export default function Blog({ allPosts }: { allPosts: IBlogPage[]; }) {
	return (
		<Layout
			isDark
			showFooter={true}
			showHeader={true}
			title='Exploring Brackets: Insights & Reviews on Top Bracket Makers'
			description='Dive deep into the world of brackets with our comprehensive articles. From understanding the basics to reviewing the best bracket makers, we cover it all. Stay updated with the latest in tournament organization'
			url={`https://www.bracketsninja.com/blog`}
		>
			<BlogHero />
			<BlogPosts blogPosts={allPosts} />
		</Layout>
	);
}

export async function getStaticProps() {
	const allPosts = await getDataFromDB<IBlogPage>('blogs',
		{
			status: 'published',
			slug: { $in: BN_ARTICLE_SLUGS }
		},
		{
			slug: 1,
			name: 1,
			excerpt: 1,
			coverImage: 1,
			author: 1,
			publishedDate: 1
		},
		{
			publishedDate: -1
		});

	return {
		props: {
			allPosts,
		}
	};
}

